// Single entry point for Highcharts and the modules every chart in the app
// expects to be present. Import this rather than 'highcharts' directly so that
// module registration and global defaults are applied exactly once.
import Highcharts from 'highcharts'
import 'highcharts/modules/exporting'
import 'highcharts/modules/offline-exporting'
import 'highcharts/modules/export-data'
import 'highcharts/modules/accessibility'
import 'highcharts/modules/treemap'

// Highcharts 13 added a palette whose `colorScheme` defaults to 'light dark',
// so chart chrome (tooltip, grid lines, axis text, the export menu button)
// follows the viewer's OS appearance setting. Nothing else in the platform does
// that: a surface is light or dark because we configured it that way. Light is
// the app-wide default, and a surface that is deliberately dark — a dashboard
// widget on the dark theme — sets `palette.colorScheme` in its own chart
// options.
Highcharts.setOptions({
  palette: {
    colorScheme: 'light',
  },
})

export default Highcharts
